import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ComunesService {

  constructor(private readonly http: HttpClient) { }

  getSignedUrl(data: any): Observable<any> {
    const body = JSON.stringify(data);
    const headers = {'Content-Type': 'application/x-www-form-urlencoded'};
    return this.http.post(`${environment.API_DOMAINS.COMUNES}/getSignedUrl`, body, {headers});
  }

  uploadFileS3(file: File | Blob, signedUrl: string, type: string): Observable<any> {
    console.log({file, signedUrl, type});
    return new Observable((observer: Subscriber<any>) => {
      const reader: any = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.addEventListener('loadend', async () => {
        try {
          const response = await fetch(signedUrl, {
            method: 'PUT',
            body: new Blob([reader.result], {type})
          });
          const text = await response.text();
          if (!response.ok) {
            throw text;
          }
          observer.next('ok');
          observer.complete();
        } catch (e) {
          observer.error(e);
        }
      });
    });
  }
}
